module.exports = __webpack_public_path__ + "img/basket-1.ecb86eaa.svg";